import { useTranslation } from "react-i18next";

import { BILLING_PAYMENT_SCHEDULE_TYPES } from "../../types/billings";
import { ColumnFilterProps } from "../../types/filters";
import { StaticOptionsListFilter } from "./StaticOptionsListFilter";

export const PaymentScheduleTypesFilter: React.FC<ColumnFilterProps> = (props) => {
  const { t } = useTranslation();

  const options = BILLING_PAYMENT_SCHEDULE_TYPES.map((type) => ({
    label: t(`billingPaymentScheduleType.${type}`),
    value: type,
  }));

  return <StaticOptionsListFilter options={options} {...props} />;
};
